import {Container, Col, Image, Row, Button, Card} from 'react-bootstrap';
import { HiCursorClick } from 'react-icons/hi'
import { TbHandClick, TbSearch } from 'react-icons/tb'
import { FiCheckCircle } from 'react-icons/fi'
import { BsCreditCard } from 'react-icons/bs'
import { GiWoodenChair, GiHotMeal } from "react-icons/gi";
import { MdCleaningServices, MdOutlineBedroomBaby } from "react-icons/md";
import SearchBar from '../../components/searchBar/SearchBar';
import './statics.scss'

export default function LongRent(props) {
    return (
        <Container style={{paddingTop: '5vh', paddingBottom: '50px', maxWidth: '80vw', height: 'unset'}}
                   className='noPadding'>
            <Row>
                <Col xs={12}>
                    <p style={{color: '#B7A57E'}}><a href='/' className='golden'>Accueil</a> > <a href='/Locataires'
                                                                                                  className='golden'>Locataires</a>
                    </p>
                </Col>
                <Col sm={12} className="noPadding">
                    <SearchBar className="searchBar"/>
                </Col>
                <Col xs={12} sm={12}>
                    <hr className="page-separator"/>
                </Col>
                <Col sm={12}>
                    <Row className="d-flex justify-content-center">
                        <Col xs={12} md={8} className="d-flex flex-column-reverse flex-lg-column align-items-end">
                            <div className="d-flex align-items-center step">
                                <TbSearch size='85' className='noDisplay'/>
                                <div className='step-content-right'>
                                    <p>Recherchez un logement en renseignant vos critères dans la barre de recherche</p>
                                    <p className='step-number'>1</p>
                                </div>
                            </div>
                            <strong className='step-name'>RECHERCHEZ</strong>
                        </Col>
                        <Col xs={12} md={8} className="d-flex flex-column-reverse flex-lg-column justify-content-start">
                            <div className="d-flex align-items-center step">
                                <div className='step-content-left'>
                                    <p className='step-number'>2</p>
                                    <p>Bingo, vous l'avez trouvé ! Réservez votre logement en moins de 3 clics</p>
                                </div>
                                <TbHandClick size='85' className='noDisplay'/>
                            </div>
                            <strong className='step-name'>SELECTIONNEZ</strong>
                        </Col>
                        <Col xs={12} md={8} className="d-flex flex-column-reverse flex-lg-column align-items-end">
                            <div className="d-flex align-items-center step">
                                <BsCreditCard size='85' className='noDisplay'/>
                                <div className='step-content-right'>
                                    <p>Payez en toute sécurité grâce à notre système sécurisé du Crédit Agricole</p>
                                    <p className='step-number'>3</p>
                                </div>
                            </div>
                            <strong className='step-name'>RÉSERVEZ</strong>
                        </Col>
                        <Col xs={12} md={8} className="d-flex flex-column-reverse flex-lg-column justify-content-start">
                            <div className="d-flex align-items-center step">
                                <div className='step-content-left'>
                                    <p className='step-number'>4</p>
                                    <p>Vous recevrez un mail de confirmation et toutes les instructions nécessaires pour
                                        faire de votre séjour une réussite. A très bientôt !</p>
                                </div>
                                <FiCheckCircle size='85' className='noDisplay'/>
                            </div>
                            <strong className='step-name'>C'EST VALIDÉ</strong>
                        </Col>
                        <Col xs={12} className='d-flex justify-content-around'>

                        </Col>
                    </Row>
                </Col>
            </Row>
            <Col xs={12} sm={12}>
                <hr className="page-separator"/>
            </Col>
            <Row className="align-items-center">
                <Col xs={12} md={4} className="d-flex justify-content-center">
                    <Image
                        loading="lazy"
                        className="images-footer-horizontal"
                        src="/images/image_page/locataire/serviette.png"
                    />
                </Col>
                <Col xs={12} md={8} className="d-flex align-items-center">
                    <div className="service-box">
                        <h3 className="text-uppercase">Services inclus</h3>
                        <ul>
                            <li><strong>Préparation du logement selon un protocole COVID</strong></li>
                            <li><strong>L'accueil</strong> directement au logement</li>
                            <li><strong>Un kit d’accueil</strong></li>
                            <li><strong>Une cuisine équipée</strong> : préparez de bons petits plats et profitez de vos
                                déjeuner grâce à un équipement complet
                            </li>
                            <li><strong>Internet gratuit</strong></li>
                            <li><strong>Le linge de maison</strong></li>
                            <li><strong>Le ménage de fin de séjour</strong> (à l'exception de la cuisine et barbecue /
                                plancha)
                            </li>
                            <li><strong>Une assistance technique</strong>: pendant les heures d'ouverture</li>
                        </ul>
                    </div>
                </Col>
            </Row>

            <Row className='d-flex flex-wrap-reverse'>
                <div className="services-container pt-5 pb-4" style={{backgroundColor: '#f5f5f5'}}>
                    <Row>
                        <Col xs={12} md={4} className="d-flex align-items-center">
                            <div>
                                <h2 className="mb-4 font-weight-bold text-dark">SERVICES A LA CARTE</h2>
                                <p className="text-center">
                                    Nous comprenons les besoins uniques de chaque voyageur et offrons des services
                                    personnalisés pour un séjour confortable et sans souci. Notre gamme de services à la
                                    carte, tels que le ménage supplémentaire et la location de matériel pour bébé,
                                    répond à toutes vos attentes pour que vous profitiez pleinement de votre séjour.
                                </p>
                            </div>
                        </Col>

                        {/* Right Column with Cards */}
                        <Col xs={12} md={8}>
                            <Row>
                                <Col xs={12} md={6} className="mb-4">
                                    <div
                                        className="d-flex shadow-sm p-3 h-100"
                                        style={{borderRadius: '5px', backgroundColor: '#fff'}}
                                    >
                                        {/* Icône à gauche */}
                                        <div className="pr-1">
                                            <Image loading='lazy' src="/images/image_page/locataire/menage.png" style={{ height: "80px" }} />
                                        </div>

                                        {/* Texte à droite */}
                                        <div>
                                            <h5 className="font-weight-bold mb-2" style={{color: '#000'}}>Ménage</h5>
                                            <p className="mb-0" style={{color: '#6c757d'}}>
                                                Réservez un ménage lors de votre séjour ainsi qu'un changement de linge
                                                pour
                                                toute la famille.
                                            </p>
                                        </div>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} className="mb-4">
                                    <div
                                        className="d-flex shadow-sm p-3 h-100"
                                        style={{borderRadius: '5px', backgroundColor: '#fff'}}
                                    >
                                        {/* Icône à gauche */}
                                        <div className="pr-1">
                                            <Image loading='lazy' src="/images/image_page/locataire/lit-bebe.png" style={{ height: "80px" }} />
                                        </div>

                                        {/* Texte à droite */}
                                        <div>
                                            <h5 className="font-weight-bold mb-2" style={{color: '#000'}}>Lit Bébé</h5>
                                            <p className="mb-0" style={{color: '#6c757d'}}>
                                                Nous vous proposons une location à 50€/séjour pour un maximum de 15
                                                jours
                                            </p>
                                        </div>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} className="mb-4">
                                    <div
                                        className="d-flex shadow-sm p-3 h-100"
                                        style={{borderRadius: '5px', backgroundColor: '#fff'}}
                                    >
                                        {/* Icône à gauche */}
                                        <div className="pr-1">
                                            <Image loading='lazy' src="/images/image_page/locataire/chaise-bebe.png" style={{ height: "80px" }} />
                                        </div>

                                        {/* Texte à droite */}
                                        <div>
                                            <h5 className="font-weight-bold mb-2" style={{color: '#000'}}>Chaise Haute</h5>
                                            <p className="mb-0" style={{color: '#6c757d'}}>
                                                Nous vous proposons une location à 25€/séjour pour un maximum de 15
                                                jours
                                            </p>
                                        </div>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} className="mb-4">
                                    <div
                                        className="d-flex shadow-sm p-3 h-100"
                                        style={{borderRadius: '5px', backgroundColor: '#fff'}}
                                    >
                                        {/* Icône à gauche */}
                                        <div className="pr-1">
                                            <Image loading='lazy' src="/images/image_page/locataire/repas.png" style={{ height: "80px" }} />
                                        </div>

                                        {/* Texte à droite */}
                                        <div>
                                            <h5 className="font-weight-bold mb-2" style={{color: '#000'}}>Et Plus Encore !</h5>
                                            <p className="mb-0" style={{color: '#6c757d'}}>
                                                Class Appart est à votre écoute pour vous offrir un service personnalisé
                                                de qualité tout au long de votre séjour.
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>


                {/*<Col xs={12} md={6} className='d-flex align-items-center bg-light p-2'>*/}
                {/*    <div>*/}
                {/*        <h3> Services à la carte</h3>*/}
                {/*        <p>Nous comprenons les besoins*/}
                {/*            uniques de chaque voyageur et*/}
                {/*            offrons des services personnalisés*/}
                {/*            pour un séjour confortable et sans*/}
                {/*            souci. Notre gamme de services à la*/}
                {/*            carte, tels que le ménage*/}
                {/*            supplémentaire et la location de*/}
                {/*            matériel pour bébé, répond à toutes*/}
                {/*            vos attentes pour que vous profitiez*/}
                {/*            pleinement de votre séjour.</p>*/}
                {/*    </div>*/}
                {/*</Col>*/}
                {/*<Col xs={12} md={4} className='d-flex justify-content-center'>*/}
                {/*    <div>*/}
                {/*        <h4 className="">Ménage</h4>*/}
                {/*        <p>Réservez un ménage lors de*/}
                {/*            votre séjour ainsi qu'un*/}
                {/*            changement de linge pour*/}
                {/*            toute la famille.</p>*/}
                {/*    </div>*/}
                {/*    <Image loading='lazy' className="images-footer-horizontal" src="/images/footerPages/Services.webp" />*/}
                {/*</Col>*/}
            </Row>
            <Col xs={12} sm={12}>
                <hr className="page-separator"/>
            </Col>

            <div className="text-center my-4">
                <h2 className="font-weight-bold text-dark">NOS AVANTAGES</h2>
                <p className="text-muted" style={{color: "#c5a87c"}}>
                    Pourquoi choisir Class Appart ?
                </p>

                <div className="mt-4">
                    <div className="mb-4">
                        <p className="mb-0">
                            <strong>Logements de Haut Standing :</strong> Nos logements sont
                            soigneusement sélectionnés pour leur qualité et leur confort,
                            garantissant une expérience de séjour exceptionnelle.
                        </p>
                        <div className="d-flex justify-content-center mt-2">
                            <span
                                style={{
                                    display: "inline-block",
                                    width: "6px",
                                    height: "6px",
                                    backgroundColor: "#c5a87c",
                                    borderRadius: "50%",
                                }}
                            ></span>
                        </div>
                    </div>

                    <div className="mb-4">
                        <p className="mb-0">
                            <strong>Concept Économique :</strong> Profitez d'un excellent
                            rapport qualité-prix avec nos offres compétitives, conçues pour
                            maximiser votre satisfaction sans compromis sur la qualité.
                        </p>
                        <div className="d-flex justify-content-center mt-2">
                            <span
                                style={{
                                    display: "inline-block",
                                    width: "6px",
                                    height: "6px",
                                    backgroundColor: "#c5a87c",
                                    borderRadius: "50%",
                                }}
                            ></span>
                        </div>
                    </div>

                    <div className="mb-4">
                        <p className="mb-0">
                            <strong>Service "All Inclusive" :</strong> Bénéficiez d'un service
                            tout compris sans frais cachés, incluant l'accueil personnalisé, le
                            kit d'accueil, le linge de maison, l'accès internet gratuit, et bien
                            plus encore.
                        </p>
                    </div>

                    <a href="/Contact">
                        <Button variant="secondary">
                            Demander un devis
                        </Button>
                    </a>
                </div>
            </div>
        </Container>
    )
}

